import React, { useRef } from "react";
import styles from "./Features.module.css";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import FeatureItem from "./FeatureItem";

function  Features() {  
    const featuresRef = useRef(
        [
            ["Pulse Rate", "Apnea Detection", "Pulse Trace", "Inhale Exhale Ratio"],
            ["Heart Rate Variability", "Upper & Lower Breath Trace", "Respiratory Line Length", "478 Facial Landmarks (with iris tracking)"],
            ["Breath Rate", "Talking Detection", "Blinking Detection", "Relative Blood Pressure (in progress)"]
        ]);

    return(
        <div className={styles["features-container"]}>
            <div className={styles["features-content"]}>
                <div className={styles["features-heading"]}>
                    <div className={styles["features-emblem"]}>
                        <StarRoundedIcon className={styles["star-icon"]} />
                    </div>

                    <h2>All The Necessary Features, In a Single Solution</h2>

                    <p className={styles["features-desc"]}>
                        Experience unparalleled efficiency with all the essential metrics you need, 
                        conveniently combined.
                    </p>
                </div>

                <div className={styles["feature-list"]}>
                    <div className={styles["feature-col"]}>
                        {
                            featuresRef.current[0].map((item, index) => {
                                return <FeatureItem feature={item} key={`col1${index}`} />
                            })
                        }
                    </div>

                    <div className={styles["feature-col"]}>
                        {
                            featuresRef.current[1].map((item, index) => {
                                return <FeatureItem feature={item} key={`col2${index}`} />
                            })
                        }
                    </div>

                    <div className={styles["feature-col"]}>
                        {
                            featuresRef.current[2].map((item, index) => {
                                return <FeatureItem feature={item} key={`col3${index}`} />
                            })
                        }
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Features;